var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: 11,
    clipPath: "url(#clip0_188_3629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_3629",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e66de411c5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.459473 0.459351H14.5445V14.5444H0.459473V0.459351Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_3629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.459473 0.459351H14.5445V14.5444H0.459473V0.459351Z",
    fill: "#FFD600"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66857 11.0022C9.93932 11.442 10.2335 11.8634 10.8568 11.8634C11.3803 11.8634 11.6549 11.6032 11.6549 11.2433C11.6549 10.8125 11.3709 10.6595 10.795 10.4087L10.4792 10.2741C9.56799 9.8876 8.96197 9.40322 8.96197 8.3801C8.96197 7.43717 9.68381 6.71963 10.8118 6.71963C11.615 6.71963 12.1921 6.99779 12.6084 7.72631L11.6248 8.35506C11.4085 7.9685 11.1745 7.81631 10.8118 7.81631C10.4417 7.81631 10.2073 8.04986 10.2073 8.35506C10.2073 8.73221 10.4421 8.88482 10.9839 9.11838L11.2997 9.25299C12.3737 9.71033 12.9793 10.1775 12.9793 11.2276C12.9793 12.3591 12.0857 12.9792 10.8861 12.9792C9.71275 12.9792 9.04647 12.3904 8.67557 11.6615L9.66857 11.0022ZM5.13553 11.0343C5.3335 11.3888 5.63439 11.6615 6.06709 11.6615C6.48104 11.6615 6.71932 11.4979 6.71932 10.8622V6.71924H8.02334V11.0625C8.02334 12.3798 7.25924 12.9792 6.14338 12.9792C5.13514 12.9792 4.4074 12.2961 4.11084 11.6615L5.13553 11.0343Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_3629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.23f4b1384a45b6fc6651d120e1226ba3.svg";
export { ForwardRef as ReactComponent };